import * as immg from 'data/imageImports'

    export const Project = [
        {
            id:1,
            image:`${immg.castle_w_190} 190w, ${immg.castle_w_562} 562w, ${immg.castle_w_766} 766w,${immg.castle_w_955} 955w, ${immg.castle_w_1108} 1108w,${immg.castle_w_1200} 1200w`,
            fallbacksrc:`${immg.castle_w_1200}`,
            heading : "Hostify",
            paragraph : "Hostify is domain selling and web hosting website, fully responsive to all the screen with beautiful UI.",
        },
        {
            id:2,
            image:`${immg.portfolio}`,
            heading : "Portfolio",
            fallbacksrc:`${immg.castle_w_1200}`,
            paragraph : "It  is a portfolio website, full of modern animation and fresh look that take it to the next level.",
        },



    ]